/**
 * Product page JavaScript
 */

// Metal selector functionality
function selectMetal(element) {
  const allCircles = document.querySelectorAll('.metal-circle');
  allCircles.forEach(circle => circle.removeAttribute('selected'));
  element.setAttribute('selected', 'true');

  // Update hidden variant selector if needed
  const optionPosition = element.dataset.optionPosition;
  const value = element.dataset.value;

  if (optionPosition) {
    const select = document.querySelector(`#Option${optionPosition}`);

    if (select) {
      select.value = value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // Load metal-specific content
  loadMetalContent(value);
}

// Load metal-specific description and technical description
function loadMetalContent(metalValue) {
  // Convert metal display name to key (e.g., "Oro amarillo" -> "oro_amarillo")
  const metalKey = metalValue.toLowerCase().replace(/\s+/g, '_');

  if (!window.metalVariantData || !window.metalVariantData.metals[metalKey]) {
    return;
  }

  const metalData = window.metalVariantData.metals[metalKey];
  const defaultDescDiv = document.getElementById('default-description');
  const metalDescDiv = document.getElementById('metal-description');
  const metalDescText = document.getElementById('metal-description-text');
  const detailsContent = document.getElementById('details-content');

  // Load metal-specific description (can be plain text or ADF JSON)
  if (metalData.description && typeof metalData.description === 'string' && metalData.description.trim()) {
    try {
      // Try to parse as ADF JSON (rich text)
      const descData = JSON.parse(metalData.description);

      if (descData && descData.children && Array.isArray(descData.children)) {
        // It's ADF format - render it
        let descHTML = '';

        function extractText(node) {
          let text = '';
          if (node.type === 'text' && node.value) {
            text += node.value;
          } else if (node.children && Array.isArray(node.children)) {
            node.children.forEach(child => {
              text += extractText(child);
            });
          }
          return text;
        }

        descData.children.forEach(node => {
          if (node.type === 'paragraph') {
            const text = extractText(node);
            if (text.trim()) {
              descHTML += text + ' ';
            }
          }
        });

        if (descHTML.trim()) {
          metalDescText.textContent = descHTML.trim();
          metalDescDiv.style.display = 'block';
          if (defaultDescDiv) defaultDescDiv.style.display = 'none';
        } else {
          metalDescDiv.style.display = 'none';
          if (defaultDescDiv) defaultDescDiv.style.display = 'block';
        }
      } else {
        metalDescDiv.style.display = 'none';
        if (defaultDescDiv) defaultDescDiv.style.display = 'block';
      }
    } catch (e) {
      // Not JSON, treat as plain text
      metalDescText.textContent = metalData.description;
      metalDescDiv.style.display = 'block';
      if (defaultDescDiv) defaultDescDiv.style.display = 'none';
    }
  } else {
    metalDescDiv.style.display = 'none';
    if (defaultDescDiv) defaultDescDiv.style.display = 'block';
  }

  // Load metal-specific images
  let images = metalData.images;

  // Filter out null/empty values, Liquid errors, and non-HTTP URLs
  if (Array.isArray(images)) {
    const validImages = images.filter(url =>
      typeof url === 'string' &&
      url.trim().length > 0 &&
      !url.includes('Liquid error') &&
      (url.startsWith('http') || url.startsWith('//'))
    );
    if (validImages.length > 0) {
      loadMetalImages(validImages);
    } else {
      restoreDefaultImages();
    }
  } else {
    restoreDefaultImages();
  }

  // Load metal-specific technical description
  let technicalDescData = null;
  let hasContent = false;

  if (metalData.technicalDescription) {
    try {
      // Handle both string and object formats
      technicalDescData = typeof metalData.technicalDescription === 'string'
        ? JSON.parse(metalData.technicalDescription)
        : metalData.technicalDescription;
      if (detailsContent && technicalDescData && technicalDescData.children) {
        renderTechnicalDescription(technicalDescData, detailsContent);
        hasContent = true;
      }
    } catch (e) {
      console.error('Error parsing metal technical description:', e);
      // Fallback to default technical description
      if (window.metalVariantData && window.metalVariantData.defaultTechnicalDescription) {
        try {
          const defaultTechDesc = typeof window.metalVariantData.defaultTechnicalDescription === 'string'
            ? JSON.parse(window.metalVariantData.defaultTechnicalDescription)
            : window.metalVariantData.defaultTechnicalDescription;

          if (detailsContent && defaultTechDesc && defaultTechDesc.children) {
            renderTechnicalDescription(defaultTechDesc, detailsContent);
            hasContent = true;
          }
        } catch (fallbackError) {
          console.error('Error with fallback technical description:', fallbackError);
        }
      }
    }
  } else if (window.metalVariantData && window.metalVariantData.defaultTechnicalDescription) {
    // No metal-specific tech desc, use default
    try {
      const defaultTechDesc = typeof window.metalVariantData.defaultTechnicalDescription === 'string'
        ? JSON.parse(window.metalVariantData.defaultTechnicalDescription)
        : window.metalVariantData.defaultTechnicalDescription;

      if (detailsContent && defaultTechDesc && defaultTechDesc.children) {
        renderTechnicalDescription(defaultTechDesc, detailsContent);
        hasContent = true;
      }
    } catch (e) {
      console.error('Error parsing default technical description:', e);
    }
  }

  // Show or hide the "Más información" button based on whether we have content
  // Use a small delay to ensure DOM is ready
  setTimeout(() => {
    const moreInfoContainer = document.getElementById('more-info-container');
    if (moreInfoContainer) {
      moreInfoContainer.style.display = hasContent ? 'block' : 'none';
    }
  }, 10);
}

// Helper function to render ADF technical description
function renderTechnicalDescription(technicalDescData, detailsContent) {
  let html = '';

  // Recursive function to extract text from any node structure
  function extractText(node) {
    let text = '';

    if (node.type === 'text' && node.value) {
      text += node.value;
    } else if (node.children && Array.isArray(node.children)) {
      node.children.forEach(child => {
        text += extractText(child);
      });
    }

    return text;
  }

  // Process each top-level node
  technicalDescData.children.forEach((node) => {
    // Handle paragraphs
    if (node.type === 'paragraph') {
      const text = extractText(node);
      if (text.trim()) {
        html += '<p>' + text + '</p>';
      }
    }

    // Handle lists (ordered or unordered)
    else if (node.type === 'list' || node.type === 'bulletList' || node.type === 'orderedList') {
      const listType = node.listType === 'ordered' ? 'ol' : 'ul';
      html += '<' + listType + '>';

      if (node.children && Array.isArray(node.children)) {
        node.children.forEach(listItem => {
          if (listItem.type === 'list-item' || listItem.type === 'listItem') {
            const itemText = extractText(listItem);
            if (itemText.trim()) {
              html += '<li>' + itemText + '</li>';
            }
          }
        });
      }

      html += '</' + listType + '>';
    }

    // Handle headings
    else if (node.type === 'heading') {
      const level = node.attrs?.level || 1;
      const text = extractText(node);
      if (text.trim()) {
        html += '<h' + level + '>' + text + '</h' + level + '>';
      }
    }

    // Handle any other block-level content
    else if (node.children && Array.isArray(node.children)) {
      const text = extractText(node);
      if (text.trim()) {
        html += '<p>' + text + '</p>';
      }
    }
  });

  if (html.trim()) {
    detailsContent.innerHTML = html;
  }
}

// Restore the original slideshow slides (saved before any metal switching)
function restoreDefaultImages() {
  const slideshow = document.getElementById('product-media-slideshow');
  if (!slideshow || !window._defaultSlideshowHTML) return;

  slideshow.innerHTML = window._defaultSlideshowHTML;
  currentMediaIndex = 0;
  totalMedia = slideshow.querySelectorAll('.media-slide').length;
}

// Load metal-specific images into the slideshow
function loadMetalImages(imageUrls) {
  const slideshow = document.getElementById('product-media-slideshow');
  if (!slideshow) return;

  // Handle case where imageUrls might be an error object or null
  if (!imageUrls || (imageUrls.error !== undefined)) return;

  // Handle case where imageUrls is an object (from files metafield)
  let imageArray = [];
  if (Array.isArray(imageUrls)) {
    imageArray = imageUrls.filter(url => typeof url === 'string' && url.length > 0);
  } else if (typeof imageUrls === 'object') {
    imageArray = Object.values(imageUrls).filter(url => typeof url === 'string' && url.length > 0);
  }

  if (!imageArray || imageArray.length === 0) return;

  // Remove existing slides
  const existingSlides = slideshow.querySelectorAll('.media-slide');
  existingSlides.forEach(slide => slide.remove());

  // Remove existing media-controls (which contains dots and buttons)
  const existingControls = slideshow.querySelector('.media-controls');
  if (existingControls) existingControls.remove();

  // Create new slides from metal images
  imageArray.forEach((imageUrl, index) => {
    const slide = document.createElement('div');
    slide.className = 'media-slide';
    slide.style.display = index === 0 ? 'block' : 'none';
    slide.setAttribute('data-media-id', `metal-image-${index}`);

    const img = document.createElement('img');
    img.src = imageUrl;
    img.alt = 'Product image';
    img.className = 'product-media-image';

    slide.appendChild(img);
    slideshow.appendChild(slide);
  });

  // Create media controls if there are multiple images
  if (imageArray.length > 1) {
    const mediaControls = document.createElement('div');
    mediaControls.className = 'media-controls';

    // Previous button
    const prevBtn = document.createElement('button');
    prevBtn.className = 'media-prev';
    prevBtn.textContent = '‹';
    prevBtn.onclick = () => previousMedia();

    // Dots container
    const dotsContainer = document.createElement('div');
    dotsContainer.className = 'media-dots';

    imageArray.forEach((_, index) => {
      const dot = document.createElement('span');
      dot.className = 'media-dot' + (index === 0 ? ' active' : '');
      dot.setAttribute('data-index', index);
      dot.onclick = () => goToMedia(index);
      dotsContainer.appendChild(dot);
    });

    // Next button
    const nextBtn = document.createElement('button');
    nextBtn.className = 'media-next';
    nextBtn.textContent = '›';
    nextBtn.onclick = () => nextMedia();

    mediaControls.appendChild(prevBtn);
    mediaControls.appendChild(dotsContainer);
    mediaControls.appendChild(nextBtn);
    slideshow.appendChild(mediaControls);
  }

  // Update global media tracking variables
  const slides = slideshow.querySelectorAll('.media-slide');
  totalMedia = slides.length;
  currentMediaIndex = 0;
}

// Make functions available globally
window.selectMetal = selectMetal;
window.loadMetalContent = loadMetalContent;
window.loadMetalImages = loadMetalImages;
window.restoreDefaultImages = restoreDefaultImages;
window.renderTechnicalDescription = renderTechnicalDescription;

// Product form handling
class ProductForm {
  constructor() {
    this.form = document.querySelector('#product-form');
    if (!this.form) return;
    
    this.variantIdInput = this.form.querySelector('.product-variant-id');
    this.submitButton = this.form.querySelector('[type="submit"]');
    this.selects = this.form.querySelectorAll('.product-option-select');
    
    this.init();
  }

  init() {
    // Listen for option changes
    this.selects.forEach(select => {
      select.addEventListener('change', () => this.onOptionChange());
    });

    // Handle form submission
    this.form.addEventListener('submit', (e) => this.onSubmit(e));
  }

  onOptionChange() {
    // Get all selected options
    const options = Array.from(this.selects).map(select => select.value);

    // Find matching variant
    if (typeof productVariants !== 'undefined') {

      const matchingVariant = productVariants.find(variant => {
        const match = variant.options.every((option, index) => option === options[index]);
        return match;
      });

      if (matchingVariant) {
        // Update the variant ID input
        this.variantIdInput.value = matchingVariant.id;

        // Update the price display
        this.updatePrice(matchingVariant);
      }
    }
  }

  updatePrice(variant) {
    const priceElement = document.getElementById('price');

    if (!priceElement) {
      return;
    }

    // Format price to match Liquid template format: €1.234,56 (or €1.234 if no cents)
    const formatPrice = (cents) => {
      const euros = cents / 100;

      // Use es-ES locale for formatting decimals
      const formatted = new Intl.NumberFormat('es-ES', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      }).format(euros);

      // Manually add thousands separator (.) if not present
      // Split by comma to handle decimal part
      const parts = formatted.split(',');
      const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      const decimalPart = parts[1] || '';

      // Reconstruct: integer with dots + comma + decimals
      let result = integerPart;
      if (decimalPart && decimalPart !== '00') {
        result += ',' + decimalPart;
      }

      return '€' + result;
    };

    const price = formatPrice(variant.price);
    const compareAtPrice = variant.compare_at_price ? formatPrice(variant.compare_at_price) : null;

    let priceHTML = `<span class="price-item price-item--regular">${price}</span>`;

    if (compareAtPrice && variant.compare_at_price > variant.price) {
      priceHTML += `<span class="price-item price-item--sale">${compareAtPrice}</span>`;
    }
    priceElement.innerHTML = priceHTML;
  }

  async onSubmit(e) {
    e.preventDefault();

    // Require ring size selection for ring products
    const ringSizeInput = document.getElementById('selected-ring-size');

    if (ringSizeInput && !ringSizeInput.value) {

      alert('Por favor selecciona una talla antes de añadir el anillo a la cesta.');

      const drawer = document.getElementById('sizeDrawer');

      if (drawer) {
        drawer.classList.add('active');
      }

      return;
    }

    const formData = new FormData(this.form);

    // Disable submit button
    this.submitButton.disabled = true;
    this.submitButton.textContent = 'Añadiendo...';

    try {
      const response = await fetch('/cart/add.json', {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        throw new Error('Error adding to cart');
      }

      await response.json();

      // Update cart count
      if (window.theme && window.theme.CartDrawer) {
        const cartDrawer = new window.theme.CartDrawer();
        cartDrawer.updateCartCount();
      }

      // Show success message
      this.showSuccess();

      // Don't redirect - stay on product page

    } catch (error) {
      console.error('Error:', error);
      this.showError();
    } finally {
      this.submitButton.disabled = false;
      this.submitButton.textContent = 'AÑADIR A LA CESTA';
    }
  }

  showSuccess() {
    // Simple success feedback
    const originalText = this.submitButton.textContent;
    this.submitButton.textContent = '✓ Añadido';
    this.submitButton.style.background = '#4CAF50';
    
    setTimeout(() => {
      this.submitButton.textContent = originalText;
      this.submitButton.style.background = '';
    }, 2000);
  }

  showError() {
    const originalText = this.submitButton.textContent;
    this.submitButton.textContent = 'Error - Inténtalo de nuevo';
    this.submitButton.style.background = '#f44336';
    
    setTimeout(() => {
      this.submitButton.textContent = originalText;
      this.submitButton.style.background = '';
    }, 3000);
  }
}

// Initialize product form and metal content
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProductForm();
    initializeMetalContent();
  });
} else {
  new ProductForm();
  initializeMetalContent();
}

// Initialize default metal content on page load
function initializeMetalContent() {
  // Save the original slideshow HTML immediately, before any metal switching
  const slideshow = document.getElementById('product-media-slideshow');
  if (slideshow) {
    window._defaultSlideshowHTML = slideshow.innerHTML;
  }

  // Load the default metal's content (which includes metal-specific technical description)
  if (window.metalVariantData && window.metalVariantData.mainMetal) {
    const defaultMetalValue = window.metalVariantData.mainMetal;

    const metalKeyToDisplay = (key) => {
      const words = key.split('_');
      if (words.length === 0) return key;
      const firstWord = words[0].charAt(0).toUpperCase() + words[0].slice(1).toLowerCase();
      const restWords = words.slice(1).map(w => w.toLowerCase()).join(' ');
      return restWords ? firstWord + ' ' + restWords : firstWord;
    };

    const metalDisplayValue = metalKeyToDisplay(defaultMetalValue);
    const metalCircle = document.querySelector(`[data-value="${metalDisplayValue}"]`);

    if (metalCircle) {
      selectMetal(metalCircle);
    } else {
      loadMetalContent(defaultMetalValue);
    }
  } else {
    // If no metal variant data, ensure button is hidden
    const moreInfoContainer = document.getElementById('more-info-container');
    if (moreInfoContainer) {
      moreInfoContainer.style.display = 'none';
    }
  }
}

// Handle back button
const backButton = document.querySelector('.back-button');
if (backButton) {
  backButton.addEventListener('click', () => {
    window.history.back();
  });
}
